import React,{useState,useEffect} from 'react';
import axios from 'axios';
import {fetchrootpath} from './apirootpath'

const url = `${fetchrootpath}/cropname`
export function CropList(season){
    const [result, setResult] = useState({
        loading:false,
        options: [],
        error: '',
    });
    useEffect(() => {
      const getData = async () => {
        setResult({...result,
        loading:true})
        const arr = [];
     
        await axios.get(url,
        {
            params: {season: season},
            headers: {
                'content-type': 'application/json',
                'Access-Control-Allow-Origin' : '*'}
        },
            ).then((res) => {
          let resdata = res.data;
          resdata.map((element) => {
            return arr.push({name: element.cropname, 
                label: element.cropname,
                crop_season: element.crop_season,
            });
          });
          setResult({
            ...result,
            loading:false,
            options: arr
          })
          
        })
        .catch(error => {
            setResult({...result,
              loading:false,
              error: error
            })
           });
        }
      getData();
    }, [season]);
    return result
}